import React from 'react';
import Image from 'next/image';
import { shortAddr } from '@/lib/misc/utils';
import { ChainId, NETWORK_LOGOS } from '@shared/utils/config/networks';
import { Button } from '@/components/ui/button';
import { OnFormSubmitProp, ReceiverUserData, ReceiverWalletData, StagesSendFunds } from '@shared/types/frontend/sendFunds';
import { X } from 'lucide-react';
import { ImageWithFallback } from '@/components/shared/NextImageFallback';
const ReceiverItemView = ({
  user,
  wallet,
  onFormSubmit,
  setStage,
  resetSendTo,
  shadow
}: {
  user?: ReceiverUserData;
  wallet?: ReceiverWalletData;
  onFormSubmit?: OnFormSubmitProp;
  setStage: (_: StagesSendFunds) => void;
  resetSendTo?: () => void;
  shadow?: boolean;
}) => {
  const _handleOnSelectRecentReceiver = ({
    user,
    wallet
  }: {
    user?: ReceiverUserData;
    wallet?: ReceiverWalletData;
  }) => {
    if (!onFormSubmit) return;
    if (user) {
      onFormSubmit.form.setValue('sendTo', onFormSubmit.tokenNetwork === ChainId.SOLANA ? user.solana_address : user.eth_address);
      onFormSubmit.setReceiver(user);
      setStage(StagesSendFunds.verify);
      return;
    }
    if (wallet) {
      onFormSubmit.form.setValue('sendTo', wallet.address);
      onFormSubmit.setReceiver(wallet);
      setStage(StagesSendFunds.verify);
      return;
    }
    return;
  };
  if (wallet) return <div key={wallet.address} className={`${shadow && 'genius-shadow'} flex justify-between gap-4 items-center px-4 ${!onFormSubmit ? 'p-3 rounded-md border border-genius-blue' : ''}`}>
        <div className={`flex gap-6 items-center`}>
          <ImageWithFallback alt='wallet-network' src={NETWORK_LOGOS[wallet.network]} width={100} height={100} className='w-[30px] h-[30px] rounded-md' />
          <div className='grid text-[16px] w-fit'>
            <p>{shortAddr(wallet.address)}</p>
            <p className='text-[10px] opacity-50 break-all'>{wallet.address}</p>
          </div>
        </div>
        {!onFormSubmit && <Button variant='ghost' size='icon' type='button' onClick={() => resetSendTo()}>
            <X className='w-4 h-4 text-genius-cream' />
          </Button>}
        {onFormSubmit && <Button onClick={() => _handleOnSelectRecentReceiver({
      wallet: wallet
    })} variant='blue' type='button' className='w-[71px] h-[36px] text-[12px] '>
            Send
          </Button>}
      </div>;
  if (user) return <div key={user.username} className={`${shadow && 'genius-shadow'} h-[64px] flex justify-between gap-4 items-center px-4 ${!onFormSubmit ? 'p-3 rounded-md border border-genius-blue' : ''}`}>
        <div className={`flex gap-6 items-center`}>
          <Image alt='user-avatar' src={`/static/genie/${user.pfp}`} width={100} height={100} className='w-[30px] h-[30px] rounded-md' />
          <div className='grid justify-items-start'>
            <div className='flex gap-2 text-[16px]'>
              <p>{user.first_name}</p>
              <p>{user.last_name}</p>
            </div>
            <p className='text-[12px] opacity-50'>{user.username}</p>
          </div>
        </div>
        {!onFormSubmit && <Button variant='ghost' size='icon' type='button' onClick={() => resetSendTo()}>
            <X className='w-4 h-4 text-genius-cream' />
          </Button>}
        {onFormSubmit && <Button onClick={() => _handleOnSelectRecentReceiver({
      user: user
    })} variant='blue' type='button' className='w-[71px] h-[36px] text-[12px]'>
            Send
          </Button>}
      </div>;
};
export default ReceiverItemView;